import React, { useState } from 'react'

import { useUser } from '../../contexts/UserContext'
import ChatModal from '../Chat/ChatModal'
// import ChatIcon from '../icons/Chat'

const AIAssistantButton: React.FC = () => {
  const { checkPermissions } = useUser()
  const [modalOpen, setModalOpen] = useState<boolean>(false)

  // Only show the button if user has the required permission
  if (!checkPermissions(['v2:compass:equity:compass_llm'])) {
    return null
  }

  return (
    <>
      <button
        className="fixed bottom-0 right-0 m-4 flex h-16 w-16 items-center justify-center rounded-full bg-info-dark opacity-50 shadow-md transition transition-opacity duration-100 hover:opacity-100 focus:opacity-100 focus:outline-none focus:ring-2"
        onClick={() => setModalOpen(true)}
        title="Assistente de IA"
      >
        {/* AI Sparkles Icon */}
        <svg
          className="h-8 w-8 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.091 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
          />
        </svg>
      </button>
      <ChatModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  )
}

export default AIAssistantButton
